<template>
    <div v-show="show" class="dialog">
        <p>{{question}}</p>
        <div class="buttons">
            <a class="button" v-if="yes" v-on:click="yes">Ja</a>
            <a class="button" v-if="no" v-on:click="no">Nei</a>
            <a class="button" v-if="ok" v-on:click="ok">OK</a>
            <a class="button" v-if="cancel" v-on:click="cancel">Avbryt</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: Boolean, question: String, yes: Function, no: Function, ok: Function, cancel: Function,
    },
};
</script>

<style lang="scss" scoped>
.dialog {
    position: absolute;
    background: $backgroundColor;
    border: 1px solid $borderColor;
    border-radius: 0.3rem;
    padding: 1rem;
    width: 12rem;
    text-align: left;
    margin: 0.2rem;
    right: 0;
    top: $headerHeight * 2;
    z-index: 20;
}
.buttons {
    margin-top: 1rem;
    text-align: right;
}
</style>
